export default __webpack_public_path__ + "static/media/pending services.505fafe2.svg";